export const getMuxVideoLink = (id: string): string => `https://stream.mux.com/${id}.m3u8`;

export const getMuxPosterLink = (id: string, time: number): string =>
    `https://image.mux.com/${id}/thumbnail.jpg?time=${time}`;
